module.exports = __webpack_public_path__ + "img/DE02722.c6f5423e.png";